module.exports = __webpack_public_path__ + "img/pic4.33f7dd67.png";